import Pubnub from 'pubnub';
import {
  convertIdToPubNubKind
} from '../utilities/index'


export var aaPubnub;

var aaPubnub = (function () {
  // Instance stores a reference to the Singleton
  var instance;

  function init() {
    // Singleton
    // Private methods and variables
    
    return {
      pubnub: {},
      // Public methods and variables
      setupPubnub: function (vendorInfo, uuid) {
        this.pubnub = new Pubnub({
          subscribeKey: vendorInfo.SubscriptionKey,
          authKey: vendorInfo.AuthorizationKey,
          uuid: convertIdToPubNubKind(uuid),
          ssl: true,
          keepAlive: true,
          keepAliveSettings: {
            keepAliveMsecs: 4000,
            maxSockets: 100,
            timeout: 0
          }
        })
      },
      vendorInfo: {},
      setVendorInfo: function(vendorInfo){
        this.vendorInfo = vendorInfo;
      }
    };
  };
  return {
    // Get the Singleton instance if one exists
    // or create one if it doesn't
    getInstance: function () {
      if (!instance) {
        instance = init();
      }
      return instance;
    }
  };
})();



// WEBPACK FOOTER //
// ./src/lib/pubnub/index.js